import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sortByOrder } from "../helpers";
import api from "../providers/api";

const initialState = { strategies: [], isLoading: true };

export const getPerspectives = createAsyncThunk(
  "get-perspectives",
  async () => {
    const response = await api.strategy.getAllWithPerspectives();

    response.Data.map((item) => {
      return { ...item, Perspectives: sortByOrder(item.Perspectives) };
    });

    return response?.Data;
  }
);

const perspectiveSlice = createSlice({
  name: "perspective",
  initialState,
  reducers: {
    updatePerspective: (state, action) => {
      if (state.strategies?.length === 0) return;
      const strategyIndex = state.strategies.findIndex(
        (perspective) => perspective.ID === action.payload?.Strategy?.ID
      );

      const itemIndex = state.strategies?.[
        strategyIndex
      ].Perspectives.findIndex(
        (perspective) => perspective.ID === action.payload?.ID
      );

      if (itemIndex !== -1) {
        state.strategies[strategyIndex].Perspectives[itemIndex] =
          action.payload;
      } else {
        state.strategies[strategyIndex].Perspectives.push(action.payload);
      }

      state.strategies.map((item) => {
        return {
          ...item,
          Perspectives: sortByOrder(item.Perspectives),
        };
      });
    },
    deletePerspective: (state, { payload: { strategyIndex, id } }) => {
      const itemIndex = state.strategies[strategyIndex].Perspectives.findIndex(
        (perspective) => perspective.ID === id
      );

      if (itemIndex !== -1) {
        state.strategies[strategyIndex].Perspectives.splice(itemIndex, 1);
      }
    },
  },
  extraReducers: {
    [getPerspectives.fulfilled]: (state, action) => {
      state.strategies = action.payload;
      state.isLoading = false;
    },
    [getPerspectives.pending]: (state) => {
      state.isLoading = true;
    },
    [getPerspectives.rejected]: (state) => {
      state.isLoading = false;
      // addToast.error("error", {
      //   toastId: "error",
      // });
    },
  },
});

export const { updatePerspective, deletePerspective } =
  perspectiveSlice.actions;

export default perspectiveSlice.reducer;
